module.exports = __webpack_public_path__ + "img/ma.5249c05b.svg";